import SectionTitleSimple from '../../../../section/SectionCollapse';
import TableCompare from '../TableCompare/TableCompare';

const Fields = ({ changes, title = 'Fields updated', action = '' }) => (
  <SectionTitleSimple title={title}>
    <TableCompare changes={changes} action={action} />
  </SectionTitleSimple>
);
export default Fields;
